import { BaseModalProps, ModalContentWrapper } from 'ui';

interface EmailPreviewModalProps extends BaseModalProps {
  subject: string;
  html: string;
  previewKey?: string;
}

export const buildEmailPreviewDocument = (html: string) => {
  const previewStyles = `<style>
  a { pointer-events: none !important; cursor: default !important; }
</style>`;

  if (/<html[\s>]/i.test(html)) {
    if (/<\/head>/i.test(html)) return html.replace(/<\/head>/i, `${previewStyles}</head>`);

    return html.replace(/<html([^>]*)>/i, `<html$1><head>${previewStyles}</head>`);
  }

  return `<!doctype html>
<html>
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <style>
      html, body { margin: 0; padding: 0; background: #f3f4f6; }
      body { padding: 24px; }
      a { pointer-events: none !important; cursor: default !important; }
    </style>
  </head>
  <body>${html}</body>
</html>`;
};

const EmailPreviewModal = ({
  subject,
  html,
  previewKey,
  open,
  onClose,
}: EmailPreviewModalProps) => {
  return (
    <ModalContentWrapper
      title="Email preview"
      open={open}
      onClose={onClose}
      classes={{ dialogPanel: '!max-w-[1000px]' }}
    >
      <div className="flex flex-col gap-4">
        <div className="border-b border-gray-200 pb-4">
          <div className="text-sm text-gray-500">Subject</div>
          <div className="mt-1 font-medium">{subject}</div>
        </div>
        <div className="text-sm text-gray-500">
          Links are disabled in preview. Use Copy link to open or share the task.
        </div>
        {html ? (
          <iframe
            key={previewKey}
            title="Email preview"
            srcDoc={buildEmailPreviewDocument(html)}
            sandbox=""
            tabIndex={-1}
            className="h-[650px] min-h-[600px] w-full border-0 bg-gray-100"
          />
        ) : (
          <div className="min-h-[600px] bg-gray-100 p-6 text-sm text-gray-700">
            Email preview is unavailable.
          </div>
        )}
      </div>
    </ModalContentWrapper>
  );
};

export default EmailPreviewModal;
